app.service('storageService', ['$window', '$rootScope', 'utilsService', function ($window, $rootScope, utilsService) {
    this.storage = $window.sessionStorage || $window.localStorage || null;
    this._rootscope = false;

    if (!this.storage) {
        $rootScope._localStorage = {};
        this.storage = $rootScope._localStorage;
        this._rootscope = true;
    }

    this.has = function (key) {
        if (this._rootscope) {
            return utilsService.isSet(this.storage[key]);
        }
        return utilsService.isSet(this.storage.getItem(key));
    };

    this.get = function (key) {
        if (this.has(key)) {
            if (this._rootscope) {
                return this.storage[key];
            }
            return this.storage.getItem(key);
        }
        return null;
    };

    this.set = function (key, value) {
        if (this._rootscope) {
            this.storage[key] = value;
        } else {
            this.storage.setItem(key, value);
        }
        return this;
    };

    this.remove = function (key) {
        if (this.has(key)) {
            if (this._rootscope) {
                delete this.storage[key];
            } else {
                this.storage.removeItem(key);
            }
        }
        return this;
    };

    this.clear = function () {
        if (this._rootscope) {
            this.storage = {};
        }
        this.storage.clear();
    };
}]);